import { DogSchool } from '@/data/dogSchools';

export function generateSchoolId(school: DogSchool): string {
  return `city-${school.city.replace(/\s+/g, '-').toLowerCase()}-${school.country}-${school.id}`;
}

export function generateSchoolIdFromParts(city: string, country: string, schoolId: string): string {
  return `city-${city.replace(/\s+/g, '-').toLowerCase()}-${country}-${schoolId}`;
} 